import Default from "layouts/dashboards/default";
import Cover from "layouts/authentication/sign-in/cover";
import ResetPassword from "layouts/authentication/reset-password/cover";
import ChangePassword from "layouts/authentication/change-password/cover";
import EmailVerification from "layouts/authentication/email-verification/cover";
import dashboardIcon from "./assets/icons/dashboard-icon.svg";

import categoryIcon from "./assets/icons/category-icon.svg";
import userIcon from "./assets/icons/user-icon.svg";
import referralIcon from "./assets/icons/referral-icon.svg";
import manageModeratorsIcon from "./assets/icons/manage-moderators-icon.svg";
import flaggedContentIcon from "./assets/icons/flagged-content-icon.svg";

import BusinessUsers from "layouts/dashboards/users/business-users";
import Categories from "layouts/dashboards/categories";
import Referrals from "layouts/dashboards/referrals";
import ManageModerators from "layouts/dashboards/manage-moderators";
import ManageModeratorById from "layouts/dashboards/manage-moderators/ManageModeratorById";
import FlaggedContent from "layouts/dashboards/flagged-content";
import RegularUsers from "layouts/dashboards/users/regular-users";
import UserHistory from "layouts/dashboards/user-history";
import ActivityCreated from "layouts/dashboards/user-history/activity/ActivityCreated";
import ActivityJoined from "layouts/dashboards/user-history/activity/ActivityJoined";
import ReportsMade from "layouts/dashboards/user-history/reports/ReportsMade";
import ReportsAgainst from "layouts/dashboards/user-history/reports/ReportsAgainst";
import DashboardWrapper from "layouts/DashboardWrapper";

const user = localStorage.getItem("user");
const userType = JSON.parse(user)?.role;
const isAdmin = userType === "admin";

export const routes = [
  {
    type: "collapse",
    noCollapse: true,
    name: "Login",
    key: "login",
    layout: "user",
    route: "/user/login",
    component: <Cover />,
  },
  {
    type: "collapse",
    noCollapse: true,
    name: "Reset Password",
    key: "reset-password",
    layout: "user",
    route: "/user/reset-password",
    component: <ResetPassword />,
  },
  {
    type: "collapse",
    noCollapse: true,
    name: "Change Password",
    key: "change-password",
    layout: "user",
    route: "/user/update-password",
    component: <ChangePassword />,
  },
  {
    type: "collapse",
    noCollapse: true,
    name: "Email Verification",
    key: "email-verification",
    layout: "user",
    route: "/user/email-verification",
    component: <EmailVerification />,
  },
];

export const sidebarRoutes = [
  {
    type: "collapse",
    noCollapse: true,
    name: "Dashboards",
    key: "dashboard",
    layout: "dashboard",
    icon: <img src={dashboardIcon} alt="Dashboard" />,
    iconActive: <img src={dashboardIcon} alt="Dashboard" />,
    route: "/admin/dashboard",
    component: (
      <DashboardWrapper>
        <Default />
      </DashboardWrapper>
    ),
  },
  isAdmin && {
    type: "collapse",
    noCollapse: true,
    name: "Manage Moderator",
    key: "manage-moderator",
    layout: "dashboard",
    icon: <img src={manageModeratorsIcon} alt="Moderator" />,
    iconActive: <img src={manageModeratorsIcon} alt="Moderator" />,
    route: "/admin/manage-moderator",
    component: (
      <DashboardWrapper>
        <ManageModerators />
      </DashboardWrapper>
    ),
  },
  isAdmin && {
    type: "collapse",
    name: "Users",
    key: "users",
    layout: "dashboard",
    icon: <img src={userIcon} alt="Users" />,
    iconActive: <img src={userIcon} alt="Users" />,
    collapse: [
      {
        type: "collapse",
        noCollapse: true,
        name: "Regular",
        key: "regular-users",
        route: "/admin/regular-users",
        component: (
          <DashboardWrapper>
            <RegularUsers />
          </DashboardWrapper>
        ),
      },
      {
        type: "collapse",
        noCollapse: true,
        name: "Business",
        key: "business-users",
        route: "/admin/business-users",
        component: (
          <DashboardWrapper>
            <BusinessUsers />
          </DashboardWrapper>
        ),
      },
    ],
  },
  isAdmin && {
    type: "collapse",
    noCollapse: true,
    name: "Referral",
    key: "referral",
    layout: "dashboard",
    icon: <img src={referralIcon} alt="User" />,
    iconActive: <img src={referralIcon} alt="User" />,
    route: "/admin/referral",
    component: (
      <DashboardWrapper>
        <Referrals />
      </DashboardWrapper>
    ),
  },
  isAdmin && {
    type: "collapse",
    noCollapse: true,
    name: "Categories",
    key: "categories",
    layout: "dashboard",
    icon: <img src={categoryIcon} alt="Categories" />,
    iconActive: <img src={categoryIcon} alt="Categories" />,
    route: "/admin/categories",
    component: (
      <DashboardWrapper>
        <Categories />
      </DashboardWrapper>
    ),
  },
  {
    type: "collapse",
    noCollapse: true,
    name: "Flagged Content",
    key: "flagged-content",
    layout: "dashboard",
    icon: <img src={flaggedContentIcon} alt="Flagged Content" />,
    iconActive: <img src={flaggedContentIcon} alt="Flagged Content" />,
    route: "/admin/flagged-content",
    component: (
      <DashboardWrapper>
        <FlaggedContent />
      </DashboardWrapper>
    ),
  },
  {
    type: "collapse",
    noCollapse: true,
    name: "User History",
    key: "user-history",
    layout: "dashboard",
    icon: <img src={userIcon} alt="User History" />,
    iconActive: <img src={userIcon} alt="User History" />,
    route: "/admin/user-history",
    component: (
      <DashboardWrapper>
        <UserHistory />
      </DashboardWrapper>
    ),
  },
  isAdmin && {
    layout: "dashboard",
    route: "admin/manage-moderator/:id",
    component: (
      <DashboardWrapper>
        <ManageModeratorById />
      </DashboardWrapper>
    ),
  },
  {
    layout: "dashboard",
    route: "admin/user-history/activity-created/:id",
    component: (
      <DashboardWrapper>
        <ActivityCreated />
      </DashboardWrapper>
    ),
  },
  {
    layout: "dashboard",
    route: "admin/user-history/activity-joined/:id",
    component: (
      <DashboardWrapper>
        <ActivityJoined />
      </DashboardWrapper>
    ),
  },
  {
    layout: "dashboard",
    route: "admin/user-history/reports-made/:id",
    component: (
      <DashboardWrapper>
        <ReportsMade />
      </DashboardWrapper>
    ),
  },
  {
    layout: "dashboard",
    route: "admin/user-history/reports-against/:id",
    component: (
      <DashboardWrapper>
        <ReportsAgainst />
      </DashboardWrapper>
    ),
  },
];
